import { LitElement, html, css } from 'lit'

class MovingBlocksLoaderElement extends LitElement {
  constructor() {
    super()
  }

  static properties = {
    message: { type: String },
  }

  render() {
    return html` <svg
      width="56"
      height="56"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>
        .spinner_9y7u {
          animation: spinner_fUkk 2.4s linear infinite;
          animation-delay: -2.4s;
        }
        .spinner_DF2s {
          animation-delay: -1.6s;
        }
        .spinner_q27e {
          animation-delay: -0.8s;
        }
        @keyframes spinner_fUkk {
          8.33% {
            x: 26px;
            y: 2px;
          }
          25% {
            x: 26px;
            y: 2px;
          }
          33.3% {
            x: 26px;
            y: 26px;
          }
          50% {
            x: 26px;
            y: 26px;
          }
          58.33% {
            x: 2px;
            y: 26px;
          }
          75% {
            x: 2px;
            y: 26px;
          }
          83.33% {
            x: 2px;
            y: 2px;
          }
        }
      </style>
      <rect
        class="spinner_9y7u"
        x="1"
        y="1"
        rx="2"
        width="20"
        height="20"
        fill="var(--kula-green)"
      />
      <rect
        class="spinner_9y7u spinner_DF2s"
        x="1"
        y="1"
        rx="2"
        width="20"
        height="20"
        fill="var(--kula-deep-green)"
      />
      <rect
        class="spinner_9y7u spinner_q27e"
        x="1"
        y="1"
        rx="2"
        width="20"
        height="20"
        fill="var(--kula-deep-green)"
      />
    </svg>`
  }
}

customElements.define('moving-blocks-loader', MovingBlocksLoaderElement)
export default MovingBlocksLoaderElement
